<template>
  <div
    v-if="!isDataLoaded"
    class="flex h-screen items-center justify-center"
  >
    <LoaderCircle
      class="animate-spin"
      :size="100"
    />
  </div>
</template>

<script setup lang="ts">
  import { LoaderCircle } from 'lucide-vue-next'
  import { useClientActionStore } from '../store/clientActionStore'
  import { genericErrorToast } from '@/lib/toasts'
  import { computed, onMounted, ref } from 'vue'
  import { useRoute, useRouter } from 'vue-router'

  const route = useRoute()
  const router = useRouter()
  const clientActionsStore = useClientActionStore()

  const doc_creation_token = computed(() => route.params.doc_creation_token as string)
  const case_uuid = computed(() => route.params.case_uuid as string)
  const isDataLoaded = ref(false)

  onMounted(async () => {
    try {
      const response = await clientActionsStore.getPdfExternalRedirectToken(
        doc_creation_token.value,
        case_uuid.value
      )
      if (Object.keys(response).length !== 0) {
        await router.push({
          path: `/client/portal/external/document/${response.form_token}`
        })
        isDataLoaded.value = true
      } else {
        toastError()
      }
    } catch (error) {
      toastError()
    }
  })

  function toastError() {
    genericErrorToast()
  }
</script>
